import { jsx, jsxs } from 'react/jsx-runtime';
import { isBrowser, getClassNames } from '@websolutespa/bom-core';
import { motion } from 'framer-motion';
import { useLenis } from 'lenis/react';
import { useRef, useEffect } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';

const motionItem = {
  hidden: {
    y: '40px'
  },
  show: {
    y: 0,
    transition: {
      type: 'tween',
      duration: 1
    }
  }
};
const motionBlob = {
  top: {
    y: '-15%'
  },
  bottom: {
    y: '0%',
    transition: {
      repeat: Infinity,
      repeatType: 'mirror',
      duration: 2,
      ease: 'easeInOut'
    }
  }
};
const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: .3
    }
  }
};
const Intro = () => {
  const iframeRef = useRef(null);
  const {
    Blob,
    Hints
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const {
    send,
    setIntroed
  } = useLlmView(state => state.actions);
  const skipCustomIntro = useLlmView(state => state.skipCustomIntro);
  const embedded = useLlmView(state => state.embedded);
  const lenis = useLenis();
  useEffect(() => {
    if (isBrowser) {
      const onMessage = event => {
        if (!event.data) {
          return;
        }
        const message = JSON.parse(event.data);
        switch (message.type) {
          case 'send':
            if (message.prompt && typeof message.prompt === 'string') {
              setIntroed(true);
              send(message.prompt, response => {
                // console.log('Prompt.onChunk', response.chunks);
              }, response => {
                // console.log('Prompt.onEnd', response);
              }).catch(error => {
                console.log('Intro.send.error', error);
              });
            }
            break;
          case 'resize':
            if (iframeRef.current) ;
            break;
          case 'introed':
            // console.log('onMessage.introed');
            setIntroed(message.introed);
            break;
        }
      };
      window.addEventListener('message', onMessage);
      // console.log('onMessage');
      return () => window.removeEventListener('message', onMessage);
    }
    return () => {};
  }, [setIntroed, send]);
  useEffect(() => {
    const onLenisScroll = () => {
      if (iframeRef.current) {
        const rect = iframeRef.current.getBoundingClientRect();
        console.log('onLenisScroll', rect.bottom < window.innerHeight);
        setIntroed(rect.bottom < window.innerHeight);
      }
    };
    if (lenis) {
      lenis.on('scroll', onLenisScroll);
      return () => lenis.off('scroll', onLenisScroll);
    }
    return () => {};
  }, [lenis, setIntroed]);
  if (!app) {
    return;
  }
  const contents = app.contents;
  const extendedWelcomeText = contents.extendedWelcomeText;
  const hints = (app === null || app === void 0 ? void 0 : app.contents.layoutBuilder) || [];
  return contents.customIntro ? skipCustomIntro ? null : jsx("section", {
    className: "llm__customIntro",
    children: jsx("iframe", {
      ref: iframeRef,
      className: "llm__iframe",
      src: typeof contents.customIntro === 'object' ? contents.customIntro['it'] : contents.customIntro,
      sandbox: "allow-scripts"
    })
  }) : jsx("section", {
    className: "llm__intro",
    children: jsx("div", {
      className: "llm__container",
      children: jsxs(motion.div, {
        variants: stagger,
        className: "llm__intro-wrapper llm__row",
        children: [jsxs(motion.div, {
          variants: motionItem,
          className: getClassNames('llm__intro-text llm__col', {
            '--md-6 --lg-5': hints.length > 0,
            '--sm-9 --md-8 --lg-7': hints.length === 0
          }),
          children: [jsx("div", {
            className: "llm__intro-blob",
            children: jsx(motion.div, {
              variants: motionBlob,
              initial: "top",
              animate: "bottom",
              children: jsx(Blob, {})
            })
          }), extendedWelcomeText && (embedded ? jsx(motion.h2, {
            variants: motionItem,
            className: "llm__intro-title -llm-t-display2",
            dangerouslySetInnerHTML: {
              __html: extendedWelcomeText
            }
          }) : jsx(motion.h1, {
            variants: motionItem,
            className: "llm__intro-title -llm-t-display2",
            dangerouslySetInnerHTML: {
              __html: extendedWelcomeText
            }
          }))]
        }), hints.length > 0 && jsx(motion.div, {
          variants: motionItem,
          className: "llm__intro-hints llm__col --end-md-12 --md-6 --lg-5",
          children: jsx(Hints, {
            hints: hints
          })
        })]
      })
    })
  });
};

export { Intro };
//# sourceMappingURL=intro.js.map
